export default __webpack_public_path__ + "static/media/portfolio-66.f20216c6.jpg";